(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrusel-migo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('image-carousel-banner')) {
    customElements.define(
      'image-carousel-banner',
      class ImageCarouselBanner extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          if (!this.track) return;

          this.prevBtn = this.querySelector('[data-prev]');
          this.nextBtn = this.querySelector('[data-next]');
          this.dotsEl = this.querySelector('[data-dots]');
          this.autoplay = this.dataset.autoplay === 'true';
          this.delay = (parseFloat(this.dataset.delay) || 4) * 1000;
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1, true));
          if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1, true));

          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
          this.addEventListener('touchstart', () => this.stop(), { passive: true });
          this.addEventListener('touchend', () => this.start(), { passive: true });

          // Puntos de navegación
          if (this.dotsEl) {
            this.onScroll = () => {
              if (this.raf) return;
              this.raf = requestAnimationFrame(() => {
                this.raf = null;
                this.updateDots();
              });
            };
            this.track.addEventListener('scroll', this.onScroll, { passive: true });

            if ('ResizeObserver' in window) {
              this.resizeObserver = new ResizeObserver(() => this.buildDots());
              this.resizeObserver.observe(this.track);
            } else {
              window.addEventListener('resize', this.buildDotsBound = () => this.buildDots());
            }
            this.buildDots();
          }

          // Pausa cuando el carrusel no está visible en pantalla
          this.visible = true;
          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver((entries) => {
              this.visible = entries[0].isIntersecting;
              this.visible ? this.start() : this.stop();
            });
            this.observer.observe(this);
          }

          this.start();
        }

        disconnectedCallback() {
          this.stop();
          if (this.observer) this.observer.disconnect();
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.buildDotsBound) window.removeEventListener('resize', this.buildDotsBound);
        }

        get stepWidth() {
          const slide = this.track.querySelector('.icb__slide');
          if (!slide) return 0;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          return slide.getBoundingClientRect().width + gap;
        }

        get maxScroll() {
          return this.track.scrollWidth - this.track.clientWidth;
        }

        step(direction, manual = false) {
          const w = this.stepWidth;
          const max = this.maxScroll;
          if (!w || max <= 2) return; // todas las imágenes caben, no hay nada que deslizar

          const pos = this.track.scrollLeft;

          if (direction > 0 && pos >= max - 2) {
            this.track.scrollTo({ left: 0 });
          } else if (direction < 0 && pos <= 2) {
            this.track.scrollTo({ left: max });
          } else {
            this.track.scrollBy({ left: direction * w });
          }

          if (manual) {
            this.stop();
            this.start();
          }
        }

        buildDots() {
          if (!this.dotsEl) return;
          const w = this.stepWidth;
          const max = this.maxScroll;
          const count = w && max > 2 ? Math.round(max / w) + 1 : 0;

          if (count === this.dotCount) {
            this.updateDots();
            return;
          }

          this.dotCount = count;
          this.dotsEl.innerHTML = '';
          this.dotsEl.hidden = count <= 1;

          for (let i = 0; i < count; i++) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'icb__dot';
            dot.setAttribute('aria-label', 'Ir a la imagen ' + (i + 1));
            dot.addEventListener('click', () => {
              this.track.scrollTo({ left: Math.min(i * this.stepWidth, this.maxScroll) });
              this.stop();
              this.start();
            });
            this.dotsEl.appendChild(dot);
          }
          this.updateDots();
        }

        updateDots() {
          if (!this.dotsEl || !this.dotCount) return;
          const w = this.stepWidth;
          if (!w) return;

          let index = Math.round(this.track.scrollLeft / w);
          if (this.track.scrollLeft >= this.maxScroll - 2) index = this.dotCount - 1;
          index = Math.max(0, Math.min(index, this.dotCount - 1));

          this.dotsEl.querySelectorAll('.icb__dot').forEach((dot, i) => {
            dot.setAttribute('aria-current', i === index ? 'true' : 'false');
          });
        }

        start() {
          if (!this.autoplay || this.reduceMotion || !this.visible || this.timer) return;
          this.timer = setInterval(() => this.step(1), this.delay);
        }

        stop() {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
